import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['taxId', 'taxClassification', 'taxClassificationLlc', 'taxClassificationOther'];

  taxIdTarget: HTMLInputElement;

  taxClassificationTargets: Array<HTMLInputElement>;

  taxClassificationLlcTarget: HTMLDivElement;

  taxClassificationOtherTarget: HTMLDivElement;

  connect() {
    const selected = this.taxClassificationTargets.find((button: HTMLInputElement) => button.checked);
    // @ts-expect-error TS2345 violates strict null checks
    this.show(selected, this.taxClassificationLlcTarget, 'llc');
    // @ts-expect-error TS2345 violates strict null checks
    this.show(selected, this.taxClassificationOtherTarget, 'other');
  }

  change() {
    // @ts-expect-error TS2322 violates strict null checks
    const llcInput: HTMLSelectElement = this.taxClassificationLlcTarget.querySelector('select');
    // @ts-expect-error TS2322 violates strict null checks
    const otherInput: HTMLInputElement = this.taxClassificationOtherTarget.querySelector('input');
    const selected = this.taxClassificationTargets.find((button: HTMLInputElement) => button.checked);

    this.taxClassificationLlcTarget.setAttribute('hidden', 'true');
    this.taxClassificationOtherTarget.setAttribute('hidden', 'true');

    llcInput.value = '';
    otherInput.value = '';

    // @ts-expect-error TS2345 violates strict null checks
    this.show(selected, this.taxClassificationLlcTarget, 'llc');
    // @ts-expect-error TS2345 violates strict null checks
    this.show(selected, this.taxClassificationOtherTarget, 'other');
  }

  show(selected: HTMLInputElement, wrapper: HTMLDivElement, val: string) {
    if (selected && selected.value === val) {
      wrapper.removeAttribute('hidden');
    }
  }
}
